import { ContentFragment } from '@oneaudi/falcon-tools';
import { PriceBreakdownType } from '../redux/priceBreakdownReducer';

export interface FalconContent extends Partial<ContentFragment> {
  __type: 'aem-headless';
  fields: {
    // eslint-disable-next-line
    priceBreakdownGroup?: any;
  };
}

export interface AppContent {
  __type?: 'default';
  priceBreakdownGroup: {
    regular: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    dealerDiscount: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    OEMDiscount: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    dealerMarkup: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    nonConditionalBonus: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    dealerPrice: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    dealerDocFees: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    destinationAndHandlingFees: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    retail: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    final: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    usedRetail: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    usedRegular: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    usedDealerDiscount: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    usedOEMDiscount: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    usedDealerMarkup: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    usedNonConditionalBonus: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    usedDealerPrice: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    usedDealerDocFees: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    usedDestinationAndHandlingFees: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    usedFinal: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    // Only Canadian New Vehicles
    acLevy: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    tireLevy: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    freightPDI: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    motoCouncil: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    adminFee: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
    luxuryTax: {
      isEnabled: boolean;
      label: string;
      shortDisclaimer: string;
      longDisclaimer: string;
      priceKey: string;
      vehicleType: string;
      hasTextOverride: boolean;
      textOverride: string;
    };
  };
  displayRebates: boolean;
  displayRebatesUsed: boolean;
}

export const mapContent = (content: AppContent | FalconContent): AppContent => {
  if (content?.__type !== 'aem-headless') {
    return { ...content };
  }

  return normalizeContent(content);
};

const normalizeContent = (content: FalconContent): AppContent => {
  const { priceBreakdownGroup } = content.fields;

  let priceBreakdownContentForCMS = {} as PriceBreakdownType;
  let formattedContent = {} as any;

  // eslint-disable-next-line
  if (priceBreakdownGroup) {
    const {
      isRetailEnabledUsed,
      usedRetailLabel,
      usedRetailShortDisclaimer,
      usedRetailLongDisclaimer,
      hasTextOverrideRetailUsed,
      textOverrideRetailUsed,
      isRegularPricingEnabled,
      regularPricingLabel,
      regularPricingShortDisclaimer,
      regularPricingLongDisclaimer,
      hasTextOverrideRegular,
      textOverrideRegular,
      isDealerDiscountEnabled,
      dealerDiscountLabel,
      dealerDiscountShortDisclaimer,
      dealerDiscountLongDisclaimer,
      hasTextOverrideDealerDiscount,
      textOverrideDealerDiscount,
      isOEMDiscountEnabled,
      oemDiscountLabel,
      oemDiscountShortDisclaimer,
      oemDiscountLongDisclaimer,
      hasTextOverrideOemDiscount,
      textOverrideOemDiscount,
      isDealerMarkupEnabled,
      dealerMarkupLabel,
      dealerMarkupShortDisclaimer,
      dealerMarkupLongDisclaimer,
      hasTextOverrideDealerMarkup,
      textOverrideDealerMarkup,
      isNonConditionalBonusEnabled,
      nonConditionalBonusLabel,
      nonConditionalBonusShortDisclaimer,
      nonConditionalBonusLongDisclaimer,
      hasTextOverrideNonConditionalBonus,
      textOverrideNonConditionalBonus,
      isDealerPriceEnabled,
      dealerPriceLabel,
      dealerPriceShortDisclaimer,
      dealerPriceLongDisclaimer,
      hasTextOverrideDealerPrice,
      textOverrideDealerPrice,
      isDealerDocFeesEnabled,
      dealerDocFeesLabel,
      dealerDocFeesShortDisclaimer,
      dealerDocFeesLongDisclaimer,
      hasTextOverrideDealerDocFees,
      textOverrideDealerDocFees,
      isDestinationAndHandlingFeesEnabled,
      destinationAndHandlingFeesLabel,
      destinationAndHandlingFeesShortDisclaimer,
      destinationAndHandlingFeesLongDisclaimer,
      hasTextOverrideDestinationAndHandlingFees,
      textOverrideDestinationAndHandlingFees,
      isFinalPriceEnabled,
      finalPriceLabel,
      finalPriceShortDisclaimer,
      finalPriceLongDisclaimer,
      hasTextOverrideFinal,
      textOverrideFinal,
      isRetailEnabled,
      retailLabel,
      retailShortDisclaimer,
      retailLongDisclaimer,
      hasTextOverrideRetail,
      textOverrideRetail,
      isRegularPricingEnabledUsed,
      regularPricingLabelUsed,
      regularPricingShortDisclaimerUsed,
      regularPricingLongDisclaimerUsed,
      hasTextOverrideRegularUsed,
      textOverrideRegularUsed,
      isDealerDiscountEnabledUsed,
      dealerDiscountLabelUsed,
      dealerDiscountShortDisclaimerUsed,
      dealerDiscountLongDisclaimerUsed,
      hasTextOverrideDealerDiscountUsed,
      textOverrideDealerDiscountUsed,
      isOEMDiscountEnabledUsed,
      oemDiscountLabelUsed,
      oemDiscountShortDisclaimerUsed,
      oemDiscountLongDisclaimerUsed,
      hasTextOverrideOemDiscountUsed,
      textOverrideOemDiscountUsed,
      isDealerMarkupEnabledUsed,
      dealerMarkupLabelUsed,
      dealerMarkupShortDisclaimerUsed,
      dealerMarkupLongDisclaimerUsed,
      hasTextOverrideDealerMarkupUsed,
      textOverrideDealerMarkupUsed,
      isNonConditionalBonusEnabledUsed,
      nonConditionalBonusLabelUsed,
      nonConditionalBonusShortDisclaimerUsed,
      nonConditionalBonusLongDisclaimerUsed,
      hasTextOverrideNonConditionalBonusUsed,
      textOverrideNonConditionalBonusUsed,
      isDealerPriceEnabledUsed,
      dealerPriceLabelUsed,
      dealerPriceShortDisclaimerUsed,
      dealerPriceLongDisclaimerUsed,
      hasTextOverrideDealerPriceUsed,
      textOverrideDealerPriceUsed,
      isDealerDocFeesEnabledUsed,
      dealerDocFeesLabelUsed,
      dealerDocFeesShortDisclaimerUsed,
      dealerDocFeesLongDisclaimerUsed,
      hasTextOverrideDealerDocFeesUsed,
      textOverrideDealerDocFeesUsed,
      isDestinationAndHandlingFeesEnabledUsed,
      destinationAndHandlingFeesLabelUsed,
      destinationAndHandlingFeesShortDisclaimerUsed,
      destinationAndHandlingFeesLongDisclaimerUsed,
      hasTextOverrideDestinationUsed,
      textOverrideDestinationUsed,
      isFinalPriceEnabledUsed,
      finalPriceLabelUsed,
      finalPriceShortDisclaimerUsed,
      finalPriceLongDisclaimerUsed,
      hasTextOverrideFinalUsed,
      textOverrideFinalUsed,
      // only Canadian Market needs the following Fields
      // AC Levy - NEW
      isAcLevyEnabled,
      acLevyLabel,
      acLevyShortDisclaimer,
      acLevyLongDisclaimer,
      hasTextOverrideAcLevy,
      textOverrideAcLevy,
      // Tire Levy - NEW
      isTireLevyEnabled,
      tireLevyLabel,
      tireLevyShortDisclaimer,
      tireLevyLongDisclaimer,
      hasTextOverrideTireLevy,
      textOverrideTireLevy,
      // Frieght and PDI - NEW
      isFreightPDIEnabled,
      freightPDILabel,
      freightPDIShortDisclaimer,
      freightPDILongDisclaimer,
      hasTextOverrideFreightPDI,
      textOverrideFreightPDI,
      // Moto Council Fee - NEW
      isMotoCouncilEnabled,
      motoCouncilLabel,
      motoCouncilShortDisclaimer,
      motoCouncilLongDisclaimer,
      hasTextOverrideMotoCouncil,
      textOverrideMotoCouncil,
      // Admin Fee - New
      isAdminFeeEnabled,
      adminFeeLabel,
      adminFeeShortDisclaimer,
      adminFeeLongDisclaimer,
      hasTextOverrideAdminFee,
      textOverrideAdminFee,
      // Luxury Tax - New
      isLuxuryTaxEnabled,
      luxuryTaxLabel,
      luxuryTaxShortDisclaimer,
      luxuryTaxLongDisclaimer,
      hasTextOverrideLuxuryTax,
      textOverrideLuxuryTax,
      // eslint-disable-next-line
    } = priceBreakdownGroup?.fields;

    priceBreakdownContentForCMS = {
      regular: {
        isEnabled: isRegularPricingEnabled,
        label: regularPricingLabel || 'Total MSRP	',
        shortDisclaimer: regularPricingShortDisclaimer,
        longDisclaimer: regularPricingLongDisclaimer,
        vehicleType: 'new',
        priceKey: 'regular',
        // by default this is true for regular price on New Vehicles
        hasTextOverride: hasTextOverrideRegular !== 'false',
        textOverride: textOverrideRegular,
      },
      dealerDiscount: {
        isEnabled: isDealerDiscountEnabled,
        label: dealerDiscountLabel || 'Dealer Discount',
        shortDisclaimer: dealerDiscountShortDisclaimer,
        longDisclaimer: dealerDiscountLongDisclaimer,
        vehicleType: 'new',
        priceKey: 'dealerDiscount',
        hasTextOverride: hasTextOverrideDealerDiscount === 'true',
        textOverride: textOverrideDealerDiscount,
      },
      OEMDiscount: {
        isEnabled: isOEMDiscountEnabled,
        label: oemDiscountLabel || 'OEM Discount',
        shortDisclaimer: oemDiscountShortDisclaimer,
        longDisclaimer: oemDiscountLongDisclaimer,
        vehicleType: 'new',
        priceKey: 'OEMDiscount',
        hasTextOverride: hasTextOverrideOemDiscount === 'true',
        textOverride: textOverrideOemDiscount,
      },
      dealerMarkup: {
        isEnabled: isDealerMarkupEnabled,
        label: dealerMarkupLabel || 'Dealer Markup',
        shortDisclaimer: dealerMarkupShortDisclaimer,
        longDisclaimer: dealerMarkupLongDisclaimer,
        vehicleType: 'new',
        priceKey: 'dealerMarkup',
        hasTextOverride: hasTextOverrideDealerMarkup === 'true',
        textOverride: textOverrideDealerMarkup,
      },
      nonConditionalBonus: {
        isEnabled: isNonConditionalBonusEnabled,
        label: nonConditionalBonusLabel || 'Non-conditional bonus',
        shortDisclaimer: nonConditionalBonusShortDisclaimer,
        longDisclaimer: nonConditionalBonusLongDisclaimer,
        vehicleType: 'new',
        priceKey: 'nonConditionalBonus',
        hasTextOverride: hasTextOverrideNonConditionalBonus === 'true',
        textOverride: textOverrideNonConditionalBonus,
      },
      dealerPrice: {
        isEnabled: isDealerPriceEnabled,
        label: dealerPriceLabel || 'Dealer Price',
        shortDisclaimer: dealerPriceShortDisclaimer,
        longDisclaimer: dealerPriceLongDisclaimer,
        vehicleType: 'new',
        priceKey: 'dealerPrice',
        hasTextOverride: hasTextOverrideDealerPrice === 'true',
        textOverride: textOverrideDealerPrice,
      },
      dealerDocFees: {
        isEnabled: isDealerDocFeesEnabled,
        label: dealerDocFeesLabel || 'Dealer Doc Fees',
        shortDisclaimer: dealerDocFeesShortDisclaimer,
        longDisclaimer: dealerDocFeesLongDisclaimer,
        vehicleType: 'new',
        priceKey: 'dealerDocFees',
        hasTextOverride: hasTextOverrideDealerDocFees === 'true',
        textOverride: textOverrideDealerDocFees,
      },
      destinationAndHandlingFees: {
        isEnabled: isDestinationAndHandlingFeesEnabled,
        label: destinationAndHandlingFeesLabel || 'Destination and Handling Fees',
        shortDisclaimer: destinationAndHandlingFeesShortDisclaimer,
        longDisclaimer: destinationAndHandlingFeesLongDisclaimer,
        vehicleType: 'new',
        priceKey: 'destinationAndHandlingFees',
        hasTextOverride: hasTextOverrideDestinationAndHandlingFees === 'true',
        textOverride: textOverrideDestinationAndHandlingFees,
      },
      retail: {
        isEnabled: isRetailEnabled,
        label: retailLabel || 'Retail Price',
        shortDisclaimer: retailShortDisclaimer,
        longDisclaimer: retailLongDisclaimer,
        vehicleType: 'new',
        priceKey: 'retail',
        hasTextOverride: hasTextOverrideRetail === 'true',
        textOverride: textOverrideRetail,
      },
      final: {
        isEnabled: isFinalPriceEnabled,
        label: finalPriceLabel || 'Final Price',
        shortDisclaimer: finalPriceShortDisclaimer,
        longDisclaimer: finalPriceLongDisclaimer,
        vehicleType: 'new',
        priceKey: 'final',
        hasTextOverride: hasTextOverrideFinal === 'true',
        textOverride: textOverrideFinal,
      },
      usedRegular: {
        isEnabled: isRegularPricingEnabledUsed === 'true',
        label: regularPricingLabelUsed || 'Total MSRP	',
        shortDisclaimer: regularPricingShortDisclaimerUsed,
        longDisclaimer: regularPricingLongDisclaimerUsed,
        vehicleType: 'used',
        priceKey: 'regular',
        hasTextOverride: hasTextOverrideRegularUsed === 'true',
        textOverride: textOverrideRegularUsed,
      },
      usedDealerDiscount: {
        isEnabled: isDealerDiscountEnabledUsed === 'true',
        label: dealerDiscountLabelUsed || 'Dealer Discount',
        shortDisclaimer: dealerDiscountShortDisclaimerUsed,
        longDisclaimer: dealerDiscountLongDisclaimerUsed,
        vehicleType: 'used',
        priceKey: 'dealerDiscount',
        hasTextOverride: hasTextOverrideDealerDiscountUsed === 'true',
        textOverride: textOverrideDealerDiscountUsed,
      },
      usedOEMDiscount: {
        isEnabled: isOEMDiscountEnabledUsed === 'true',
        label: oemDiscountLabelUsed || 'OEM Discount',
        shortDisclaimer: oemDiscountShortDisclaimerUsed,
        longDisclaimer: oemDiscountLongDisclaimerUsed,
        vehicleType: 'used',
        priceKey: 'OEMDiscount',
        hasTextOverride: hasTextOverrideOemDiscountUsed === 'true',
        textOverride: textOverrideOemDiscountUsed,
      },
      usedDealerMarkup: {
        isEnabled: isDealerMarkupEnabledUsed === 'true',
        label: dealerMarkupLabelUsed || 'Dealer Markup',
        shortDisclaimer: dealerMarkupShortDisclaimerUsed,
        longDisclaimer: dealerMarkupLongDisclaimerUsed,
        vehicleType: 'used',
        priceKey: 'dealerMarkup',
        hasTextOverride: hasTextOverrideDealerMarkupUsed === 'true',
        textOverride: textOverrideDealerMarkupUsed,
      },
      usedNonConditionalBonus: {
        isEnabled: isNonConditionalBonusEnabledUsed === 'true',
        label: nonConditionalBonusLabelUsed || 'Non-conditional bonus',
        shortDisclaimer: nonConditionalBonusShortDisclaimerUsed,
        longDisclaimer: nonConditionalBonusLongDisclaimerUsed,
        vehicleType: 'used',
        priceKey: 'nonConditionalBonus',
        hasTextOverride: hasTextOverrideNonConditionalBonusUsed === 'true',
        textOverride: textOverrideNonConditionalBonusUsed,
      },
      usedDealerPrice: {
        isEnabled: isDealerPriceEnabledUsed === 'true',
        label: dealerPriceLabelUsed || 'Dealer Price',
        shortDisclaimer: dealerPriceShortDisclaimerUsed,
        longDisclaimer: dealerPriceLongDisclaimerUsed,
        vehicleType: 'used',
        priceKey: 'dealerPrice',
        hasTextOverride: hasTextOverrideDealerPriceUsed === 'true',
        textOverride: textOverrideDealerPriceUsed,
      },
      usedDealerDocFees: {
        isEnabled: isDealerDocFeesEnabledUsed === 'true',
        label: dealerDocFeesLabelUsed || 'Dealer Doc Fees',
        shortDisclaimer: dealerDocFeesShortDisclaimerUsed,
        longDisclaimer: dealerDocFeesLongDisclaimerUsed,
        vehicleType: 'used',
        priceKey: 'dealerDocFees',
        hasTextOverride: hasTextOverrideDealerDocFeesUsed === 'true',
        textOverride: textOverrideDealerDocFeesUsed,
      },
      usedDestinationAndHandlingFees: {
        isEnabled: isDestinationAndHandlingFeesEnabledUsed === 'true',
        label: destinationAndHandlingFeesLabelUsed || 'Destination and Handling Fees',
        shortDisclaimer: destinationAndHandlingFeesShortDisclaimerUsed,
        longDisclaimer: destinationAndHandlingFeesLongDisclaimerUsed,
        vehicleType: 'used',
        priceKey: 'destinationAndHandlingFees',
        hasTextOverride: hasTextOverrideDestinationUsed === 'true',
        textOverride: textOverrideDestinationUsed,
      },
      usedFinal: {
        isEnabled: isFinalPriceEnabledUsed === 'true',
        label: finalPriceLabelUsed || 'Final Price',
        shortDisclaimer: finalPriceShortDisclaimerUsed,
        longDisclaimer: finalPriceLongDisclaimerUsed,
        vehicleType: 'used',
        priceKey: 'final',
        hasTextOverride: hasTextOverrideFinalUsed === 'true',
        textOverride: textOverrideFinalUsed,
      },
      usedRetail: {
        isEnabled: isRetailEnabledUsed === 'true',
        label: usedRetailLabel || 'Retail Price',
        shortDisclaimer: usedRetailShortDisclaimer,
        longDisclaimer: usedRetailLongDisclaimer,
        vehicleType: 'used',
        priceKey: 'retail',
        hasTextOverride: hasTextOverrideRetailUsed === 'true',
        textOverride: textOverrideRetailUsed,
      },
      // ONLY CANADIAN MARKET
      acLevy: {
        isEnabled: isAcLevyEnabled === 'true',
        label: acLevyLabel || 'Federal Air Conditioning Excise Tax',
        shortDisclaimer: acLevyShortDisclaimer,
        longDisclaimer: acLevyLongDisclaimer,
        vehicleType: 'new',
        priceKey: 'acLevy',
        hasTextOverride: hasTextOverrideAcLevy === 'true',
        textOverride: textOverrideAcLevy,
      },
      tireLevy: {
        isEnabled: isTireLevyEnabled === 'true',
        label: tireLevyLabel || 'Tire Levy',
        shortDisclaimer: tireLevyShortDisclaimer,
        longDisclaimer: tireLevyLongDisclaimer,
        vehicleType: 'new',
        priceKey: 'tireLevy',
        hasTextOverride: hasTextOverrideTireLevy === 'true',
        textOverride: textOverrideTireLevy,
      },
      freightPDI: {
        isEnabled: isFreightPDIEnabled === 'true',
        label: freightPDILabel || 'Freight and PDI',
        shortDisclaimer: freightPDIShortDisclaimer,
        longDisclaimer: freightPDILongDisclaimer,
        vehicleType: 'new',
        priceKey: 'freightPDI',
        hasTextOverride: hasTextOverrideFreightPDI === 'true',
        textOverride: textOverrideFreightPDI,
      },
      motoCouncil: {
        isEnabled: isMotoCouncilEnabled === 'true',
        label: motoCouncilLabel || 'Motor Vehicle Council Fee',
        shortDisclaimer: motoCouncilShortDisclaimer,
        longDisclaimer: motoCouncilLongDisclaimer,
        vehicleType: 'new',
        priceKey: 'motoCouncil',
        hasTextOverride: hasTextOverrideMotoCouncil === 'true',
        textOverride: textOverrideMotoCouncil,
      },
      adminFee: {
        isEnabled: isAdminFeeEnabled === 'true',
        label: adminFeeLabel || 'Admin Fee',
        shortDisclaimer: adminFeeShortDisclaimer,
        longDisclaimer: adminFeeLongDisclaimer,
        vehicleType: 'new',
        priceKey: 'adminFee',
        hasTextOverride: hasTextOverrideAdminFee === 'true',
        textOverride: textOverrideAdminFee,
      },
      luxuryTax: {
        isEnabled: isLuxuryTaxEnabled === 'true',
        label: luxuryTaxLabel || 'Luxury Tax',
        shortDisclaimer: luxuryTaxShortDisclaimer,
        longDisclaimer: luxuryTaxLongDisclaimer,
        vehicleType: 'new',
        priceKey: 'luxuryTax',
        hasTextOverride: hasTextOverrideLuxuryTax === 'true',
        textOverride: textOverrideLuxuryTax,
      },
    };
  }
  formattedContent = {
    priceBreakdownGroup: priceBreakdownContentForCMS,
    displayRebates: priceBreakdownGroup?.fields?.displayRebates || false,
    displayRebatesUsed: priceBreakdownGroup?.fields?.displayRebatesUsed || false,
  };

  return formattedContent;
};

export default mapContent;
